import reducer from './reducer';

export * from './actions';
export * from './selectors';
export * from './thunks';

export default reducer;



// WEBPACK FOOTER //
// ./src/lib/dataLayer/allergies/index.js